import { render, staticRenderFns } from "./FinishOrder.vue?vue&type=template&id=5ca14050&scoped=true&"
import script from "./FinishOrder.vue?vue&type=script&lang=js&"
export * from "./FinishOrder.vue?vue&type=script&lang=js&"
import style0 from "./FinishOrder.vue?vue&type=style&index=0&id=5ca14050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca14050",
  null
  
)

export default component.exports